import axios from "axios";
import { toast } from "react-toastify";

/**
 * Verifies MFA OTP code
 * @param {string} email - User email
 * @param {string} otp - OTP code to verify
 * @param {string} loginToken - Login token for authentication
 * @param {Function} onSuccess - Callback function called on successful verification (token, user)
 * @param {Function} onError - Optional callback function called on error for custom error handling
 * @returns {Promise} Promise that resolves with { token, user } on success
 */
export const verifyMFAOTP = async (email, otp, loginToken, onSuccess, onError) => {
  const api = localStorage.getItem("api");
  
  try {
    const response = await axios.post(
      `${api}/mfa/verify`,
      {
        email,
        otp,
      },
      {
        headers: {
          Authorization: `Bearer ${loginToken}`,
          "Content-Type": "application/json",
        },
      }
    );

    const { token, user } = response?.data;

    if (token && user) {
      toast.success("MFA verified successfully!", {
        position: toast.POSITION.BOTTOM_RIGHT,
      });
      if (onSuccess) {
        onSuccess(token, user);
      }
      return { token, user };
    } else {
      throw new Error("Invalid response from MFA verify");
    }
  } catch (err) {
    console.error(err);
    const errorMessage = "Invalid OTP. Please try again.";
    toast.error(errorMessage, {
      position: toast.POSITION.BOTTOM_RIGHT,
    });
    
    if (onError) {
      onError(errorMessage);
    }
    throw err;
  }
};


